'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _communicationMethodTypes = require('ui-addon-upgrades/_core/communicationMethods/communicationMethodTypes');

var _communicationMethodTypes2 = _interopRequireDefault(_communicationMethodTypes);

var _upgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface');

var _communicationMethodsConfig = require('ui-addon-upgrades/_core/communicationMethods/communicationMethodsConfig');

var _communicationMethodsConfig2 = _interopRequireDefault(_communicationMethodsConfig);

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _CommunicationButton = require('ui-addon-upgrades/_core/communicationMethods/CommunicationButton');

var _CommunicationButton2 = _interopRequireDefault(_CommunicationButton);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _ComponentWithPartials = require('UIComponents/mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

var _productProperties = require('ui-addon-upgrades/_core/common/constants/productProperties');

var _productProperties2 = _interopRequireDefault(_productProperties);

var _url = require('ui-addon-upgrades/_core/common/navigation/url');

var _PurchaseMotionTypes = require('ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes');

var _mon084Utils = require('./mon084Utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INITIAL = _communicationMethodTypes2.default.INITIAL;


var connectMon084CommunicationMethods = function connectMon084CommunicationMethods(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { onDark: false, buttonType: 'selectableButton' };

  var CommunicationMethods = function (_React$Component) {
    _inherits(CommunicationMethods, _React$Component);

    function CommunicationMethods(props) {
      _classCallCheck(this, CommunicationMethods);

      var _this = _possibleConstructorReturn(this, (CommunicationMethods.__proto__ || Object.getPrototypeOf(CommunicationMethods)).call(this, props));

      var _this$props = _this.props,
          upgradeData = _this$props.upgradeData,
          _overrideCommunicationMethodKey = _this$props._overrideCommunicationMethodKey,
          onConfirm = _this$props.onConfirm,
          onCancel = _this$props.onCancel;


      var communicationMethodsConfigToUse = null;

      if (_overrideCommunicationMethodKey === _communicationMethodTypes2.default.MEETING) {
        var communicationMethod = _communicationMethodsConfig2.default.filter(function (_ref) {
          var communicationKey = _ref.communicationKey;

          return _communicationMethodTypes2.default.MEETING === communicationKey;
        })[0];

        communicationMethod.onClick({ upgradeData: upgradeData, onCancel: onCancel }, onConfirm);
        communicationMethodsConfigToUse = _communicationMethodsConfig2.default;
      }

      _this.state = {
        selectedCommunicationMethod: props._overrideCommunicationMethodKey || INITIAL,
        communicationMethodsConfigToUse: communicationMethodsConfigToUse
      };

      _this.handleUpgradeClick = _this.handleUpgradeClick.bind(_this);
      _this.setSelectedCommunicationMethod = _this.setSelectedCommunicationMethod.bind(_this);
      _this.componentWillMount = _ComponentWithPartials2.default.componentWillMount.bind(_this);
      _this.componentWillUnmount = _ComponentWithPartials2.default.componentWillUnmount.bind(_this);
      _this.partial = _ComponentWithPartials2.default.partial.bind(_this);
      return _this;
    }

    _createClass(CommunicationMethods, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            upgradeData = _props.upgradeData,
            _overrideCommunicationMethodKey = _props._overrideCommunicationMethodKey;


        tracker.track('communicationMethodsInteraction', _extends({
          action: 'viewed'
        }, upgradeData));

        if (_overrideCommunicationMethodKey) {
          this.setState({
            communicationMethodsConfigToUse: _communicationMethodsConfig2.default
          });
          return;
        }

        (0, _mon084Utils.fetchIsEligibleForMon084)().then(function (isEligibleForMon084) {
          if (isEligibleForMon084) {
            (0, _mon084Utils.fetchMon084Param)().then(function (group) {
              var communicationMethodsConfigToUse = group === 'variant' ? _mon084Utils.mon084CommunicationMethodsConfig : _communicationMethodsConfig2.default;
              _this2.setState({ communicationMethodsConfigToUse: communicationMethodsConfigToUse });
            });
          } else {
            _this2.setState({
              communicationMethodsConfigToUse: _communicationMethodsConfig2.default
            });
          }
        });
      }
    }, {
      key: 'handleUpgradeClick',
      value: function handleUpgradeClick() {
        var upgradeData = this.props.upgradeData;
        var upgradeLink = _productProperties2.default[upgradeData.upgradeProduct].upgradeLink;


        tracker.track('contactSalesModalInteraction', _extends({
          action: 'clicked upgrade'
        }, upgradeData));
        (0, _url.openNewTab)(upgradeLink(upgradeData.source, upgradeData.upgradeProduct));
      }
    }, {
      key: 'setSelectedCommunicationMethod',
      value: function setSelectedCommunicationMethod(selectedCommunicationMethod) {
        this.setState({ selectedCommunicationMethod: selectedCommunicationMethod });
      }
    }, {
      key: 'renderButtonComponents',
      value: function renderButtonComponents() {
        var _this3 = this;

        var _props2 = this.props,
            upgradeData = _props2.upgradeData,
            onConfirm = _props2.onConfirm,
            onCancel = _props2.onCancel;
        var communicationMethodsConfigToUse = this.state.communicationMethodsConfigToUse;


        return communicationMethodsConfigToUse && communicationMethodsConfigToUse.map(function (communicationMethod, key) {
          var communicationKey = communicationMethod.communicationKey,
              onClick = communicationMethod.onClick,
              image = communicationMethod.image,
              useIllustration = communicationMethod.useIllustration;

          return _react2.default.createElement(_CommunicationButton2.default, {
            key: key,
            image: image,
            useIllustration: useIllustration,
            communicationKey: communicationKey,
            onClick: _this3.partial(onClick, { upgradeData: upgradeData, onCancel: onCancel }, onConfirm),
            setSelectedCommunicationMethod: _this3.setSelectedCommunicationMethod,
            upgradeData: upgradeData,
            buttonType: options.buttonType
          });
        });
      }
    }, {
      key: 'renderSelectedMethodComponent',
      value: function renderSelectedMethodComponent() {
        var _state = this.state,
            selectedCommunicationMethod = _state.selectedCommunicationMethod,
            communicationMethodsConfigToUse = _state.communicationMethodsConfigToUse;
        var _props3 = this.props,
            onConfirm = _props3.onConfirm,
            upgradeData = _props3.upgradeData;


        var communicationMethod = communicationMethodsConfigToUse && communicationMethodsConfigToUse.filter(function (_ref2) {
          var communicationKey = _ref2.communicationKey;

          return selectedCommunicationMethod === communicationKey;
        })[0];
        if (!communicationMethod || !communicationMethod.SelectedMethodComponent) {
          return null;
        }

        var SelectedMethodComponent = communicationMethod.SelectedMethodComponent;


        return _react2.default.createElement(SelectedMethodComponent, {
          onDark: options.onDark,
          onConfirm: onConfirm,
          upgradeData: upgradeData,
          setSelectedCommunicationMethod: this.setSelectedCommunicationMethod
        });
      }
    }, {
      key: 'renderUpgradeComponent',
      value: function renderUpgradeComponent() {
        var purchaseMotionEligibility = this.props.upgradeData.purchaseMotionEligibility;


        if (!purchaseMotionEligibility) {
          return null;
        }

        var selectedCommunicationMethod = this.state.selectedCommunicationMethod;

        var isEligibleToTouchlesslyPurchase = purchaseMotionEligibility.indexOf(_PurchaseMotionTypes.BUY_TOUCHLESS) !== -1;

        if (!isEligibleToTouchlesslyPurchase || selectedCommunicationMethod !== INITIAL) {
          return null;
        }

        var linkUse = options.onDark ? 'link-on-dark' : 'link';

        return _react2.default.createElement(
          _UIButton2.default,
          {
            className: 'm-top-2 text-center upgrade',
            use: linkUse,
            onClick: this.handleUpgradeClick,
            block: true
          },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.pqlModal.upgradeNow' })
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _overrideCommunicationMethodKey = this.props._overrideCommunicationMethodKey;


        var newProps = {
          buttonComponents: this.renderButtonComponents(),
          selectedMethodComponent: this.renderSelectedMethodComponent(),
          upgradeComponent: this.renderUpgradeComponent()
        };
        if (_overrideCommunicationMethodKey === _communicationMethodTypes2.default.MEETING) {
          return null;
        }

        return _react2.default.createElement(Component, _extends({}, newProps, (0, _underscore.omit)(this.props, '_overrideCommunicationMethodKey')));
      }
    }]);

    return CommunicationMethods;
  }(_react2.default.Component);

  var propsToEnforce = (0, _underscore.omit)(Component.propTypes, ['buttonComponents', 'selectedMethodComponent', 'upgradeComponent']);

  CommunicationMethods.propTypes = _extends({}, propsToEnforce, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
    onConfirm: _react.PropTypes.func.isRequired,
    _overrideCommunicationMethodKey: _react.PropTypes.string
  });

  return CommunicationMethods;
};

exports.default = connectMon084CommunicationMethods;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/connectMon084CommunicationMethods.js
// module id = 553
// module chunks = 3 4 5